export default "__VITE_ASSET__5ddc87c3__"